import {
    GET_USERS,
    SET_PAGE,
    SET_ROWS,
    SET_USER_TYPE_FILTER,
    REMOVE_CREW_USER,
    REMOVE_USER,
    SET_PROFILE,
    GET_DEPARTMENTS,
    GET_AREAS,
    SET_FILTER_DEPARTMENT_NAME,
    SET_FILTER_AREA_NAME,
    SET_USER_FILTER,
    SET_LAST_ACTIVE
} from "./types";

const INITIAL_STATE = {
    requesting: false,
    users: false,
    page: 0,
    row: 50,
    filter: "admin",
    deleting: false,
    userProfile: false,
    departmentType: "all_departments",
    areaType: "all_areas",
    departments: false,
    areas: false,
    userFilter: false,
    lastActive: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_USERS.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case GET_USERS.FAIL: {
            return { ...state, requesting: false, users: false };
        }
        case GET_USERS.SUCCESS: {
            return { ...state, requesting: false, users: action.payload };
        }
        case SET_PAGE: {
            return { ...state, page: action.payload };
        }
        case SET_LAST_ACTIVE: {
            return { ...state, lastActive: action.payload };
        }
        case SET_PROFILE: {
            return { ...state, userProfile: action.payload };
        }
        case SET_USER_FILTER: {
            return { ...state, userFilter: action.payload };
        }
        case SET_ROWS: {
            return { ...state, row: action.payload };
        }
        case SET_USER_TYPE_FILTER: {
            return { ...state, filter: action.payload };
        }
        case REMOVE_USER.REQUEST: {
            return { ...state, deleting: true };
        }
        case REMOVE_USER.FAIL: {
            return { ...state, deleting: false };
        }
        case REMOVE_USER.SUCCESS: {
            return { ...state, deleting: false };
        }
        case REMOVE_CREW_USER.REQUEST: {
            return { ...state, deleting: true };
        }
        case REMOVE_CREW_USER.FAIL: {
            return { ...state, deleting: false };
        }
        case REMOVE_CREW_USER.SUCCESS: {
            return { ...state, deleting: false };
        }
        case GET_DEPARTMENTS.REQUEST: {
            return { ...state, requesting: true, departments: false };
        }
        case GET_DEPARTMENTS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                departments: action.payload,
            };
        }
        case GET_DEPARTMENTS.FAIL: {
            return { ...state, requesting: false, departments: false };
        }
        case GET_AREAS.REQUEST: {
            return { ...state, requesting: true, areas: false };
        }
        case GET_AREAS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                areas: action.payload,
            };
        }
        case GET_AREAS.FAIL: {
            return { ...state, requesting: false, areas: false };
        }
        case SET_FILTER_DEPARTMENT_NAME: {
            return { ...state, departmentType: action.payload };
        }
        case SET_FILTER_AREA_NAME: {
            return { ...state, areaType: action.payload };
        }
        default: {
            return { ...state };
        }
    }
};
